<template>
  <div class="upload-photo-component">
    <div
      class="upload-photo-container"
      :style="{ backgroundImage: 'url(' + imageUri + ')' }"
      @mouseenter="hover = true"
      @mouseleave="hover = false"
    >
      <slot></slot>
    </div>

    <div
      :class="['btn-edit-photo', { 'full-opacity': hover }]"
      @click="$emit('click-add')"
    >
      <i class="fi fi-pencil"></i>
    </div>
  </div>
</template>

<script>
export default {
  name: "PhotoUploadContainer",

  props: {
    imageUri: {
      type: String,
      default: "",
    },
  },

  data: () => ({
    hover: false,
  }),
};
</script>

<style>
.upload-photo-component {
  position: relative;
  height: 100%;
  width: 100%;
}

.upload-photo-container {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  height: 100%;
  width: 100%;
}

.btn-edit-photo {
  position: absolute;
  right: 8px;
  top: 8px;
  width: 32px;
  height: 32px;
  color: white;
  opacity: 0;
  transition: all 0.25s ease-in-out;
  cursor: pointer;
  background-color: rgba(0, 0, 0, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

.btn-edit-photo i {
  font-size: 16px;
  color: white;
  text-shadow: 0px 0px 3px rgba(0, 0, 0, 0.5);
}

.btn-edit-photo:hover {
  opacity: 1 !important;
  background-color: rgba(0, 0, 0, 0.8);
}

.full-opacity {
  opacity: 1 !important;
}
</style>
